import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, PackageCheck, Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const badge = (status) =>
  status === "shipped"
    ? "bg-blue-50 border-blue-200 text-blue-700"
    : status === "paid"
    ? "bg-emerald-50 border-emerald-200 text-emerald-700"
    : "bg-amber-50 border-amber-200 text-amber-700";

export const StoreOrders = () => {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    axios.get(`${API}/store/orders`)
      .then(({ data }) => setOrders(data.orders))
      .catch(() => setOrders([]));
  }, []);

  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm p-8 mb-6" data-testid="store-orders-section">
      <div className="flex items-center gap-2 mb-4">
        <PackageCheck className="w-5 h-5 text-primary" />
        <h3 className="text-lg font-semibold text-gray-900">My Orders</h3>
      </div>
      {orders === null && (
        <div className="flex items-center gap-2 text-sm text-gray-500"><Loader2 className="w-4 h-4 animate-spin" /> Loading orders…</div>
      )}
      {orders?.length === 0 && (
        <p className="text-sm text-gray-500" data-testid="store-orders-empty">No orders yet — browse the Herb Store to place your first one.</p>
      )}
      <div className="space-y-4">
        {orders?.map((o) => (
          <div key={o.id} className="border border-gray-200 rounded-2xl p-5" data-testid={`order-${o.id}`}>
            <div className="flex items-start justify-between gap-3 mb-2">
              <div>
                <p className="font-semibold text-gray-900">#{o.id.slice(0, 8).toUpperCase()}</p>
                <p className="text-xs text-gray-400">{o.created_at?.slice(0, 10)}</p>
              </div>
              <span className={`text-xs font-semibold border rounded-full px-3 py-1 ${badge(o.status)}`} data-testid="order-status">
                {o.status === "shipped" ? "Shipped — on its way!" : o.status === "paid" ? "Paid — typically ships in 3–7 working days" : "Awaiting payment"}
              </span>
            </div>
            <p className="text-sm text-gray-600">
              {o.items.map((i) => `${i.quantity}× ${i.name}`).join(" · ")}
            </p>
            {(o.status === "paid" || o.status === "shipped") && (
              <div className="flex flex-wrap gap-2 mt-2">
                {o.items.filter((i) => i.herb_id).map((i) => (
                  <Link key={i.herb_id} to={`/herbs/${i.herb_id}#reviews`}
                        data-testid={`rate-herb-${i.herb_id}`}
                        className="inline-flex items-center gap-1 text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 rounded-full px-2.5 py-1 hover:bg-amber-100 transition-colors">
                    <Star className="w-3 h-3" /> Rate {i.name}
                  </Link>
                ))}
              </div>
            )}
            <p className="text-sm font-semibold text-gray-900 mt-2">£{(o.total_gbp ?? 0).toFixed(2)} <span className="text-gray-400 font-normal">(incl. £{(o.shipping_gbp ?? 0).toFixed(2)} shipping{o.service_fee_gbp ? ` + £${o.service_fee_gbp.toFixed(2)} service` : ""})</span></p>
          </div>
        ))}
      </div>
    </div>
  );
};
